<div
  class="artifact-container tw-relative tw-w-full tw-h-full"
  [style.height]="artifact.height || '600px'">
  <!-- Sandboxed iframe that renders AI-generated code -->
  <!-- allow-same-origin required to load external scripts (Highcharts) from same origin -->
  <iframe
    #artifactFrame
    [src]="iframeSrc"
    sandbox="allow-scripts allow-downloads"
    class="tw-w-full tw-h-full tw-border-0 tw-rounded-lg"></iframe>

  <!-- Loading overlay -->
  <div
    *ngIf="isLoading"
    class="tw-absolute tw-inset-0 tw-flex tw-items-center tw-justify-center tw-rounded-lg">
    <div class="spinner"></div>
  </div>
</div>
